import * as React from "react";
import { Link } from "react-scroll";
import classNames from "classnames";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

type Props = {
  to: string;
  labelTranslationKey: string;
  onSetActive: (to: string) => void;
  isActive: boolean;
  containerId?: string;
  noMargin?: boolean;
};

export const ScrollLink: React.FC<Props> = ({
  to,
  labelTranslationKey,
  onSetActive,
  isActive,
  containerId,
  noMargin = false,
}) => {
  const { t } = useTranslation();

  const className = classNames(
    "hover:atlas-text-blue-600",
    "hover:atlas-border-background-action-alt",
    "hover:atlas-no-underline",
    "atlas-border-b-2",
    "atlas-p-2",
    "atlas-pt-3",
    "atlas-pb-5",
    "atlas-no-underline",
    "atlas-cursor-pointer",
    {
      "atlas-ml-2": !noMargin,
      "atlas-text-blue-600": isActive,
      "atlas-border-background-action-alt": isActive,
      "atlas-border-transparent": !isActive,
      "atlas-text-neutral-600": !isActive,
    }
  );

  return (
    <Link
      className={className}
      role="link"
      to={to}
      containerId={containerId}
      spy
      smooth
      onSetActive={onSetActive}
    >
      {t(labelTranslationKey)}
    </Link>
  );
};
